import '../styles/SkeletonCard.css';

const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-image" />
    <div className="skeleton-content">
      <div className="skeleton-line title" />
      <div className="skeleton-line description" />
      <div className="skeleton-line description" />
      <div className="skeleton-line meta" />
    </div>
  </div>
);

export default SkeletonCard;
